import { Lab } from '../model';

/** Euclidean distance in the a-b chroma plane (ignores L). */
export function euclideanDeltaC(reference?: Lab, sample?: Lab): number | undefined {
  if (!reference || !sample) return undefined;
  return Math.sqrt(
    Math.pow(reference.a - sample.a, 2) +
    Math.pow(reference.b - sample.b, 2)
  );
}
